export default __webpack_public_path__ + "static/media/trashCan.a2234772.svg";